export default "__VITE_ASSET__80c8bd80__"